import { useFeatureFlag } from '@/composables/featureFlags.js'
import { useLocumUserQuery } from '@/composables/locum.js'
import { useAuth } from '@/composables/useAuth.js'
import { isSamePage } from '@/utils/middleware.js'
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (isSamePage(to, from) || to.meta?.skipMiddleware) {
    return
  }

  // skip on auth pages - user is not yet authenticated
  if (
    to.name === 'provetId-auth-locum' ||
    to.name === 'provetId-auth-login' ||
    to.name === 'provetId-auth-login-verify'
  ) {
    return
  }

  const isLocumManagementFeatureEnabled = useFeatureFlag(
    'temporary.new_frontend.locum_management',
  )

  const { user } = useAuth()
  const isLocum = computed(
    () =>
      user.value?.attributes?.is_locum && isLocumManagementFeatureEnabled.value,
  )

  if (!isLocum.value) {
    return
  }

  const locumUserDetail = useLocumUserQuery(user.value.id ?? '')

  await until(() => locumUserDetail.isSuccess || locumUserDetail.isError).toBe(
    true,
    { timeout: 5000, throwOnTimeout: false },
  )

  const permanent =
    locumUserDetail.data?.relationships?.available_departments_permanent ?? []
  const nonPermanent =
    locumUserDetail.data?.relationships?.available_departments_non_permanent ??
    []

  const hasNoDepartments = permanent.length === 0 && nonPermanent.length === 0

  if (!locumUserDetail.isSuccess || hasNoDepartments) {
    return navigateTo({ name: 'provetId-auth-locum' }, { replace: true })
  }
})
